import AOS from 'aos';
import * as GLOBALS from '../globals';

export default class AOSClass {
    static init() {
        return new AOSClass();
    }

    constructor() {
        AOS.init({
            duration: 700
        });

        this.resetCardDelay();

        window.addEventListener("resize", this.resetCardDelay);
    }

    resetCardDelay() {
        const cards = document.querySelectorAll('[class^=cards] [class^=card][data-aos]');

        if (cards == null) return;

        cards.forEach((card) => {
            if (card.dataset.index == null) return;
            
            let modulus = 1;
            if (window.innerWidth > GLOBALS.BREAKPOINT_MD) modulus = 2;
            
            if(window.innerWidth > GLOBALS.BREAKPOINT_LG) modulus = 3;

            card.setAttribute('data-aos-delay', (card.dataset.index % modulus) * 100);
        });
    }
}